import { axiosGetCall } from "../utils/AxiosCalls.js";

export const sendOtp = async (url, payload) => {
  return axiosGetCall(url, payload);
};

export const verifyOtp = async (url, payload) => {
  return axiosGetCall(url, payload);
};
